module.exports = __webpack_public_path__ + "static/media/img-arrow-l2r--white.b58abb06.svg";